<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <el-col :span="20" class="logo">
        <img src="../assets/logo4.png" />
        <span>ERP</span>
      </el-col>
      <el-col :span="4" class="userinfo">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link userinfo-inner">{{sysUserName}}</span>
          <el-dropdown-menu slot="dropdown">
            <!--<el-dropdown-item>我的消息</el-dropdown-item>
						<el-dropdown-item>设置</el-dropdown-item>-->
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-col>
    <el-col :span="24" class="main">
      <aside>
        <el-menu :default-active="$route.path" class="el-menu-vertical-demo" theme="dark" unique-opened router>
          <template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
            <el-submenu :index="index+''" v-if="!item.leaf">
              <template slot="title">
                <i :class="item.iconCls"></i>{{item.name}}</template>
              <el-menu-item v-for="child in item.children" :index="child.path" v-if="!child.hidden" @click="reloadUrl(child)">{{child.name}}</el-menu-item>
            </el-submenu>
            <el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path">
              <i :class="item.iconCls"></i>{{item.children[0].name}}</el-menu-item>
          </template>
        </el-menu>
      </aside>
      <section class="content-container">
        <div class="grid-content bg-purple-light">
          <div class="grid-content-inner">
            <el-col :span="24" class="breadcrumb-container">
              <strong class="title" id="routename">{{routerName}}</strong>
              <el-breadcrumb separator="/" v-show="$route.name!=''" class="breadcrumb-inner">
                <el-breadcrumb-item v-for="item in $route.matched" :to="{ path: item.path}">
                  {{ item.name }}
                </el-breadcrumb-item>
              </el-breadcrumb>
            </el-col>
            <el-col :span="24" class="content-wrapper">
              <transition name="slide-fade">
                <router-view ref="comp"></router-view>
              </transition>
            </el-col>
          </div>
        </div>
      </section>
    </el-col>
  </el-row>
</template>

<script>
import { requestLogout } from "@api/adminApi";
import { cloneDeep, util, isCorrectVal, isDate, lg } from "utils";
export default {
  methods: {
    /*
		*重新加载路由地址，刷新页面
		*@item
		*/
    reloadUrl(item) {
      //试课审核点击左侧菜单 退回 试听审核页面
      if (item.path === "/Order/testClassAudit") {
        this.$refs.comp.testclass = false;
        this.$store.dispatch("getRouterName", "试课审核");
      }
      if (typeof this.$refs.comp.handleCurrentChange == "function") {
        this.$refs.comp.handleCurrentChange(1);
      }
    },
    //退出登录
    logout: function() {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {}).then(() => {
        var logoutParams = { Sid: _this.sysSid, Session: _this.sysSession };
        requestLogout(logoutParams).then(response => {
          let { StateCode, StateMsg, Data, Cnt } = response.data;
          util.doResult(_this, response, () => {
            sessionStorage.removeItem("user");
            _this.$router.push("/login");
          });
        });
      });
    }
  },
  watch: {
    "$route.name": function(val) {
      this.$store.dispatch("getRouterName", this.$route.name);
    }
  },
  created() {
    this.$store.dispatch("getRouterName", this.$route.name);
    this.$store.dispatch("getSession");
    this.$store.dispatch("getCustomerLevelList");
    this.$store.dispatch("getCustomerSourceList");
    this.$store.dispatch("getAgentTypeList");
    this.$store.dispatch("getAgentList"); //获取幼儿园管理中的代理商管理
    this.$store.dispatch("getProjectTypeSignMateriel");
    //this.$store.dispatch('getAllCity');
    this.$store.dispatch("getAllProvince");
  },
  computed: {
    sysSid() {
      return this.$store.state.sysSid;
    },
    sysSession() {
      return this.$store.state.sysSession;
    },
    sysUserName() {
      return this.$store.state.sysUserName;
    },
    routerName() {
      return this.$store.state.routerName;
    }
  }
};
</script>
<style lang="scss">
@import "src/common/sass/base.scss";
@import "src/lib/QQPhoto-master/css/style.scss";
@import "src/lib/js-toast/js-toast.scss";
</style>
<style scoped lang="scss">
// .picitem{
// 	width:100%;border:4px solid RGB(205,205,205);border-radius:3px;line-height:0px;
// 	.itemcontent{
// 		width:100%;display:block
// 	}
// }
.slide-fade-enter-active {
  transition: all 0.5s ease;
}

.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-active {
  transform: translateY(10px);
  opacity: 0;
}

.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  .header {
    height: 60px;
    line-height: 60px;
    background: #1f2d3d;
    color: #c0ccda;
    .userinfo {
      text-align: right;
      padding-right: 35px;
      .userinfo-inner {
        color: #c0ccda;
        cursor: pointer;
        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin: 10px 0px 10px 10px;
          float: right;
        }
      }
    }
    .logo {
      font-size: 22px;
      img {
        width: 40px;
        float: left;
        margin: 10px 10px 10px 18px;
      }
      .txt {
        color: #20a0ff;
      }
    }
  }
  .main {
    background: #324057;
    position: absolute;
    top: 60px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    overflow: hidden;
    aside {
      position: absolute;
      left: 0px;
      top: 0px;
      bottom: 0px;
      width: 230px;
      overflow: auto;
    }
    .content-container {
      background: #f1f2f7;
      position: absolute;
      right: 0px;
      top: 0px;
      bottom: 0px;
      left: 230px;
      overflow: hidden;
      padding: 20px;
      .grid-content {
        overflow-y: auto;
        width: 100%;
        height: 100%;
        .grid-content-inner {
          position: relative;
          width: 100%;
          height: 100%;
        }
      }
      .breadcrumb-container {
        position: absolute;
        top: 0px;
        height: 30px;
        left: 0px;
        right: 0px;
        .title {
          width: 200px;
          float: left;
          color: #475669;
        }
        .breadcrumb-inner {
          float: right;
        }
      }

      .content-wrapper {
        position: absolute;
        top: 30px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        box-sizing: border-box;
        overflow: auto;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// Home.vue?05fe126d